export const notNull = (object, handlerMap = null) => {
  if (!object) return null

  return handlerMap(object)
}
